import { render, staticRenderFns } from "./OffersIndex.vue?vue&type=template&id=04f210f6&"
import script from "./OffersIndex.vue?vue&type=script&lang=js&"
export * from "./OffersIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports